document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll(".ss-btn-video-play").forEach(btn => {
    btn.addEventListener("click" , function() {

      if(this.getAttribute("data-state") == "play") {
          this.closest(".ss-video-container").querySelector("video").play();
          this.setAttribute("data-state", "stop");
      }else {
          this.closest(".ss-video-container").querySelector("video").pause();
          this.setAttribute("data-state", "play");
      }
    });
  });
  
  document.querySelectorAll(".ss-btn-volume-control").forEach(btn => {
    btn.addEventListener("click" , function() {
      if(this.getAttribute("data-state") == "mute") {
          this.closest(".ss-video-container").querySelector("video").muted = true;
          this.setAttribute("data-state", "unmute");
      }else {
          this.closest(".ss-video-container").querySelector("video").muted = false;
          this.setAttribute("data-state", "mute");
      }
    });
  });

  var quantity_buttons = document.querySelectorAll(".pdp-hero__btn-quantity-change");
  quantity_buttons.forEach(item => {
    item.addEventListener("click", function() {
      var qty_mode = this.getAttribute("data-mode");
      var qty_input = document.querySelector(".pdp-hero__quantity input[name='quantity']");
      var qty_val = parseInt(qty_input.value);

      if(qty_mode == "plus" &&  qty_val < qty_input.getAttribute("max")) {
        qty_input.value = qty_val + 1;
      } else if(qty_mode == "minus" &&  qty_val > 1) {
        qty_input.value = qty_val - 1;
      }
    });
  });

  if(document.querySelectorAll(".pdp-hero__thumb-button")) {
    var media_buttons = document.querySelectorAll(".pdp-hero__thumb-button");

    media_buttons.forEach(item => {
      item.addEventListener("click", function(event) {
        event.preventDefault();
        var sliderContent = document.querySelector(".pdp-hero__gallery-thumbs-container .pdp-hero__gallery-thumbs");
        var itemHeight = sliderContent.querySelector(".swiper__thumb").clientHeight + 8;
        console.log("sliderContent", sliderContent);
        if(this.classList.contains("ss-next-button")) {
          sliderContent.scrollTo({ top: sliderContent.scrollLeft + itemHeight, behavior : "smooth" });
        } else {
          sliderContent.scrollTo({ top: sliderContent.scrollLeft - itemHeight, behavior : "smooth" });
        }
      });
    });
  }


  var timer;

  timer = setInterval(function() {
    if(document.querySelector(".button.okendo__all-reviews")) {
      var seeAllReview = document.querySelector(".button.okendo__all-reviews");

      seeAllReview.addEventListener("click", function() {
        console.log("dddddddddddddddd");
     });

     clearInterval(timer);
    }
  });

});
